import React from 'react';

export default function FunnelParityAlertStrip({ alerts = [] }) {
  const rows = Array.isArray(alerts) ? alerts.filter(Boolean) : [];
  if (rows.length === 0) return null;

  return (
    <section className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 dark:border-amber-700 dark:bg-amber-900/20">
      <p className="text-xs font-black text-amber-700 dark:text-amber-300">Tutarsızlık Alarmı</p>
      <ul className="mt-2 space-y-1.5">
        {rows.map((item, index) => (
          <li key={`parity-alert-${index}`} className="text-sm text-amber-800 dark:text-amber-200">
            {item}
          </li>
        ))}
      </ul>
    </section>
  );
}
